// app/ui/src/utils/soundManager.js
class SoundManager {
    constructor() {
        this.audio = null;
        this.enabled = localStorage.getItem('soundNotifications') === 'true';
        this.initialized = false;
        this.permissionGranted = false;
    }

    createAudio() {
        if (!this.audio) {
            this.audio = new Audio();
            this.audio.preload = 'auto';
            this.audio.src = `${process.env.PUBLIC_URL}/sounds/sound-effects-library-cash-register-sound.mp3`;
        }
    }

    async initialize() {
        if (this.initialized) return true;
        
        try {
            this.createAudio();
            // Only attempt to play if we have user interaction
            if (document.hasFocus()) {
                await this.audio.play();
                this.audio.pause();
                this.audio.currentTime = 0;
                this.initialized = true;
                this.permissionGranted = true;
                return true;
            }
            return false;
        } catch (error) {
            console.warn('Sound initialization deferred - waiting for user interaction');
            return false;
        }
    }

    async requestPermission() {
        if (!this.enabled) return false;

        try {
            if ('Notification' in window) {
                const permission = await Notification.requestPermission();
                if (permission === 'granted') {
                    const initResult = await this.initialize();
                    this.permissionGranted = initResult;
                    return initResult;
                }
            }
            return false;
        } catch (error) {
            console.error('Permission request failed:', error);
            return false;
        }
    }

    async toggle() {
        this.enabled = !this.enabled;
        localStorage.setItem('soundNotifications', this.enabled);
        
        if (this.enabled) {
            // Try to initialize when enabling
            await this.requestPermission();
        }
        
        return this.enabled;
    }

    async playNotification() {
        if (!this.enabled || !this.permissionGranted) return;

        try {
            if (!this.initialized) {
                const initResult = await this.initialize();
                if (!initResult) return;
            }

            if (this.audio) {
                this.audio.currentTime = 0;
                const playPromise = this.audio.play();
                
                if (playPromise) {
                    await playPromise;
                }
            }
        } catch (error) {
            console.warn('Sound playback deferred - waiting for user interaction');
        }
    }
}

export const soundManager = new SoundManager();